<div class="mb-2">
  <div class="parent_divider">
    <div class="divider_text me-1">{{ headerText | translate }}</div>
    @let plannedDate =
      accurateDateTime
        ? (accurateDateTime | localizedDateFormat)
        : (plannedDateTime | localizedDateFormat);
    <div
      class="divider_text me-1"
      [attr.data-test-id]="
        'wilson-tooltip-shift-schedule-details:date:' + plannedDate
      "
      [ngClass]="{
        reported_divider_text: timeType === ActivityDeviationStatus.Reported,
      }"
    >
      {{ plannedDate }}
    </div>
    <nz-divider class="mt-1 mb-2"></nz-divider>
  </div>
  <div class="times">
    <div class="value time">
      @let plannedTime = plannedDateTime | localizedTimeFormat;
      <span
        [attr.data-test-id]="
          'wilson-tooltip-shift-schedule-details:time:' + plannedTime
        "
        class="fw-normal me-1"
      >
        {{ plannedTime }}
      </span>
      @let derivedPlannedLocation =
        (plannedLocation?.locationCode ?? '') +
        ' ' +
        $safeNavigationMigration(plannedLocation?.name);
      <span
        [attr.data-test-id]="
          'wilson-tooltip-shift-schedule-details:location' +
          derivedPlannedLocation
        "
        class="value"
      >
        {{ derivedPlannedLocation }}
      </span>
    </div>
    @if (timeType === ActivityDeviationStatus.Reported) {
      <div class="reported-value time">
        <span class="fw-normal me-1">
          {{ accurateDateTime | localizedTimeFormat }}
        </span>
        <span class="reported-value">
          {{ reportedLocation?.locationCode }} {{ reportedLocation?.name }}
        </span>
      </div>
    } @else {
      @if (!!timeDifference && timeDifference !== 0) {
        <div>
          @if (timeType === ActivityDeviationStatus.Deviated) {
            <span>
              <nz-tag [nzColor]="timeDifference > 0 ? 'volcano' : 'green'">
                {{ accurateDateTime | localizedTimeFormat }} ({{
                  timeDifference > 0 ? '+' + timeDifference : timeDifference
                }})
              </nz-tag>
            </span>
          }
        </div>
      }
    }
  </div>
</div>
